import moment from 'moment'

const DATE_FMT = 'YYYY-MM-DD'
const TIME_FMT = 'HH:mm:ss'
const FULL_DT_FMT = [DATE_FMT, TIME_FMT].join(' ')

export default [
    (function (value, data) {
        if (value === false) return true
        
        let { stopDate, stopTime, startDateTime } = data
        
        if (!moment.isMoment(stopDate) || !moment.isMoment(stopTime)) return false
        if (!moment.isMoment(startDateTime)) {
            startDateTime = moment(startDateTime, FULL_DT_FMT)
            if (!startDateTime.isValid()) return false
        }
        
        let autoStopTime = moment(
            [stopDate.format(DATE_FMT), stopTime.format(TIME_FMT)].join(' '),
            FULL_DT_FMT
        )

        let threshold = startDateTime
            .add(10, 'minutes')
            .startOf('minute')

        return autoStopTime.isSameOrAfter(threshold)
    })
]